/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Drastic_Tech_Target_Bitrate_LabelInputs */

const en_drastic_tech_target_bitrate_label = /** @type {(inputs: Drastic_Tech_Target_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target Bitrate (kilobits)`)
};

const fr_drastic_tech_target_bitrate_label = /** @type {(inputs: Drastic_Tech_Target_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Debit cible (kilobits)`)
};

const de_drastic_tech_target_bitrate_label = /** @type {(inputs: Drastic_Tech_Target_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel-Bitrate (Kilobit)`)
};

const it_drastic_tech_target_bitrate_label = /** @type {(inputs: Drastic_Tech_Target_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitrate di destinazione (kilobit)`)
};

const ru_drastic_tech_target_bitrate_label = /** @type {(inputs: Drastic_Tech_Target_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевой битрейт (килобиты)`)
};

const es_drastic_tech_target_bitrate_label = /** @type {(inputs: Drastic_Tech_Target_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasa de bits objetivo (kilobits)`)
};

const zh_cn2_drastic_tech_target_bitrate_label = /** @type {(inputs: Drastic_Tech_Target_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标比特率（千比特）`)
};

const ja_drastic_tech_target_bitrate_label = /** @type {(inputs: Drastic_Tech_Target_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ターゲットビットレート（キロビット）`)
};

const hi_drastic_tech_target_bitrate_label = /** @type {(inputs: Drastic_Tech_Target_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्ष्य बिटरेट (किलोबिट)`)
};

const pt_pt2_drastic_tech_target_bitrate_label = /** @type {(inputs: Drastic_Tech_Target_Bitrate_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de bits alvo (quilobits)`)
};

/**
* | output |
* | --- |
* | "Target Bitrate (kilobits)" |
*
* @param {Drastic_Tech_Target_Bitrate_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const drastic_tech_target_bitrate_label = /** @type {((inputs?: Drastic_Tech_Target_Bitrate_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Drastic_Tech_Target_Bitrate_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_drastic_tech_target_bitrate_label(inputs)
	if (locale === "de") return de_drastic_tech_target_bitrate_label(inputs)
	if (locale === "it") return it_drastic_tech_target_bitrate_label(inputs)
	if (locale === "ru") return ru_drastic_tech_target_bitrate_label(inputs)
	if (locale === "es") return es_drastic_tech_target_bitrate_label(inputs)
	if (locale === "zh-CN") return zh_cn2_drastic_tech_target_bitrate_label(inputs)
	if (locale === "ja") return ja_drastic_tech_target_bitrate_label(inputs)
	if (locale === "hi") return hi_drastic_tech_target_bitrate_label(inputs)
	if (locale === "pt-PT") return pt_pt2_drastic_tech_target_bitrate_label(inputs)
	return en_drastic_tech_target_bitrate_label(inputs)
});